const NAVBAR_IMAGE_SELECTOR = [
  ".navbar__dropdown .nav__link--secondary-overlay-img",
  ".navbar__dropdown .nav__link--secondary-icon",
].join(", ");

function deferImage(img) {
  if (!img || img.dataset.navbarDeferredInit === "true") return;

  const src = img.getAttribute("src");
  const srcset = img.getAttribute("srcset");
  const sizes = img.getAttribute("sizes");

  if (src) {
    img.dataset.navbarDeferredSrc = src;
    img.removeAttribute("src");
  }

  if (srcset) {
    img.dataset.navbarDeferredSrcset = srcset;
    img.removeAttribute("srcset");
  }

  if (sizes) {
    img.dataset.navbarDeferredSizes = sizes;
    img.removeAttribute("sizes");
  }

  img.loading = "lazy";
  img.decoding = "async";
  img.fetchPriority = "low";
  img.dataset.navbarDeferredInit = "true";
}

function loadDeferredImage(img) {
  if (!img || img.dataset.navbarDeferredLoaded === "true") return;

  if (img.dataset.navbarDeferredSrc) {
    img.setAttribute("src", img.dataset.navbarDeferredSrc);
  }

  if (img.dataset.navbarDeferredSrcset) {
    img.setAttribute("srcset", img.dataset.navbarDeferredSrcset);
  }

  if (img.dataset.navbarDeferredSizes) {
    img.setAttribute("sizes", img.dataset.navbarDeferredSizes);
  }

  img.dataset.navbarDeferredLoaded = "true";
}

function loadImagesInWrap(wrap) {
  if (!wrap) return;
  wrap.querySelectorAll(NAVBAR_IMAGE_SELECTOR).forEach(loadDeferredImage);
}

export function initDeferredNavbarImages() {
  const wraps = Array.from(document.querySelectorAll(".navbar__dropdown-wrap"));
  if (!wraps.length) return;

  wraps.forEach((wrap) => {
    wrap.querySelectorAll(NAVBAR_IMAGE_SELECTOR).forEach(deferImage);

    const activate = () => loadImagesInWrap(wrap);

    wrap.addEventListener("pointerenter", activate, { passive: true });
    wrap.addEventListener("focusin", activate);
    wrap.addEventListener("click", activate, true);

    if (wrap.classList.contains("is-open") || wrap.classList.contains("is-active")) {
      activate();
    }
  });
}
